angular.module('unica_invitation_group.invitation_group_services')

.factory('InvitationGroupAssignService', function($http, getBaseApiURL) {

	var invitationGroupAssignService = {};

	invitationGroupAssignService.assign = function( eventId, notificationId, invitationsData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-group/assign/' + eventId + '/' + notificationId ,
			data: {
				invitations: invitationsData
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.notification_invitations;
			}

		});
	};

	invitationGroupAssignService.list = function (eventId, notificationId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-group/assign-list/' + eventId + '/' + notificationId ,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_group_invitations;
			}

		});
	};

	invitationGroupAssignService.delete = function (notificationEmailId)
	{
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/invitation-group/assign-delete/' + notificationEmailId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return invitationGroupAssignService;

});